import Button from 'lib/components/Button/Button'
import AdminContext from 'lib/context/AdminContext'
import { buildQueryString, FILTER_QUERY_KEYS, PATHS, QUERY_KEYS } from 'lib/util/routing'
import ProductCategory, { getDisplayNameByCategory } from 'pages/Home/ProductCategory'
import SectionHeader from 'pages/Home/sections/SectionHeader'
import SkillLevelDropdown from 'pages/Home/sections/SkillLevelDropdown/SkillLevelDropdown'
import Series from 'pages/Home/Series'
import SeriesFilter from 'pages/Home/SeriesFilter/SeriesFilter'
import SkillLevel from 'pages/Home/SkillLevel'
import React, { useContext } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { Link, RouteComponentProps, withRouter } from 'react-router-dom'

import RecordedWebinarSort from '../RecordedWebinarSort'
import RecordedWebinarType from '../RecordedWebinarType'
import SearchInput from '../search/SearchInput'
import SearchResults from '../search/SearchResults'
import useSearchInput from '../search/useSearchInput'
import useSearchQuery from '../search/useSearchQuery'
import AddRecordedWebinarButton from './admin/AddRecordedWebinarButton'
import RecordedWebinarsSortDropdown from './RecordedWebinarsSortDropdown'

export interface RecordedWebinarsHeaderProps extends RouteComponentProps {
  currentProductCategory: ProductCategory
  searchResults?: RecordedWebinarType[]
  selectedSeries?: Series
  loading: boolean
  selectedSkillLevel: SkillLevel
  series: Series[]
  selectedSort: RecordedWebinarSort
}

export default withRouter(function RecordedWebinarsHeader(props: RecordedWebinarsHeaderProps) {
  const {
    currentProductCategory,
    loading,
    location,
    searchResults,
    selectedSkillLevel,
    selectedSeries,
    selectedSort,
    series
  } = props
  const [t] = useTranslation()
  const { showAdminControls } = useContext(AdminContext)
  const { searchInput, setSearchInput, clearSearchInput } = useSearchInput()
  const search = useSearchQuery()
  const category = getDisplayNameByCategory(t)[currentProductCategory]

  return (
    <SectionHeader>
      <SectionHeader.Title>{t('home.recordedWebinarsSection.header.title', { category })}</SectionHeader.Title>
      {showAdminControls && <AddRecordedWebinarButton series={series} />}
      <SectionHeader.Container>
        <SectionHeader.Subtitle>
          <Trans i18nKey="home.recordedWebinarsSection.header.subtitle">
            <Link
              to={{
                pathname: PATHS.upcoming,
                search: buildQueryString(location, FILTER_QUERY_KEYS)
              }}>
              <Button variant="link">REPLACED</Button>
            </Link>
          </Trans>
        </SectionHeader.Subtitle>
        <SearchInput input={searchInput} setInput={setSearchInput} clearSearchInput={clearSearchInput} />
      </SectionHeader.Container>
      {!loading && search ? (
        <SearchResults clearSearchInput={clearSearchInput} searchResults={searchResults} />
      ) : (
        <SectionHeader.Filters>
          {!loading && (
            <SeriesFilter
              clearQueryKeys={[QUERY_KEYS.sort, QUERY_KEYS.skill]}
              selectedSeries={selectedSeries}
              series={series}
            />
          )}
          {!loading && !selectedSeries && <SkillLevelDropdown selectedSkillLevel={selectedSkillLevel} />}
          {!loading && !selectedSeries && <RecordedWebinarsSortDropdown selectedSort={selectedSort} />}
        </SectionHeader.Filters>
      )}
    </SectionHeader>
  )
})
